/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconOval = createReactComponent("outline", "oval", "IconOval", [["path", { "d": "M12 12m-6 0a6 9 0 1 0 12 0a6 9 0 1 0 -12 0", "key": "svg-0" }]]);

export { IconOval as default };
//# sourceMappingURL=IconOval.mjs.map
